import { Box, Divider, Stack, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { CreditApplication, VendorOpportunity } from '@trnsact/trnsact-shared-types';


export const ApplicantInfo = ({
  vendorOpportunity,
  creditApplication,
  commonClasses,
}: {
  vendorOpportunity: VendorOpportunity;
  creditApplication: CreditApplication;
  commonClasses: any,
}) => {

  const classes = useStyles();

  return <Box className={commonClasses.lenderDealerContactInfoBlock} sx={{ mt: 3 }}>
    <Stack className={commonClasses.infoRows} spacing={1} divider={<Divider />}>
      <Box className={classes.infoRow}>
        <Typography fontWeight={500}>Policy Holder</Typography>
        <Typography fontWeight={500}>{creditApplication.businessName || vendorOpportunity.potentialCustomer?.name}</Typography>
      </Box>
      <Box className={classes.infoRow}>
        <Typography>Address</Typography>
        <Typography>{creditApplication.primaryContact?.address}</Typography>
      </Box>
      <Box className={classes.infoRow}>
        <Typography>Contact</Typography>
        <Typography>{creditApplication.primaryContact?.firstName} {creditApplication.primaryContact?.lastName}</Typography>
      </Box>
      <Box className={classes.infoRow}>
        <Typography>Phone</Typography>
        <Typography>{creditApplication.primaryContact?.phone}</Typography>
      </Box>
      <Box className={classes.infoRow}>
        <Typography>Email</Typography>
        <Typography>{creditApplication.primaryContact?.email}</Typography>
      </Box>
    </Stack>
  </Box>
};

const useStyles = makeStyles(() => {
  return {
    infoRow: {
      display: 'Grid',
      gridTemplateColumns: '1fr 3fr'
    },
  };
});
